import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// Admin
import Dashboard from './Admin/Dashboard';

// Login Register
import Login from './Login/Login';
import Register from './Register/RegisterAdmin';

// Staff Gathering
import ScanQrGathering from './GatheringStaff/ScanQrGathering';

// Admin Pembekalan Wisuda One Page
import AdminPembekalanOnePage from './WisudaUpiYptk/AdminPembekalanOnePage';

//404
import NotFound from './404/404';

const App = () => {
  return (
    <div>
    <Router>
          <Routes>
            {/* Admin */}
            <Route path="/" element={<Dashboard />} />
            <Route path="/admin/dashboard" element={<Dashboard />} />

            {/* Login Register */}
            <Route path="/admin/login" element={ <Login />} />
            <Route path="/admin/register" element={ <Register />} />

            {/* Staff Gathering */}
            <Route path="/gathering-upi/scan" element={<ScanQrGathering />} />

            {/* Admin Wisuda One Page */}
            <Route path="/pembekalan/admin/one-control" element={<AdminPembekalanOnePage/>} />

            {/* Route 404 harus paling bawah */}
            <Route path="*" element={<NotFound />} />
          </Routes>
    </Router>
    </div>
  );
};


export default App;